<template>
    <div class="menu" :class="{ 'menu--show': visible }">
        <button type="button" class="close btn" aria-label="Close" @click="handleCloseButtonClicked">
            <slot name="close">&times;</slot>
        </button>
        <slot></slot>
    </div>
</template>

<script>
    import Responsive from '../../mixins/responsive';
    import { useClickOut } from "../../use/click-out";

    export default {
        mixins: [Responsive],
        data() {
            return {
                visible: false,
                listenForClickOut: false,
            }
        },
        methods: {
            open() {
                this.visible = true;
                setTimeout(() => {
                    this.listenForClickOut = true;
                }, 0);
                if(window.innerWidth < this.breakpoints.md) {
                    document.body.style.overflow = 'hidden';
                    document.body.style.height = `${window.innerHeight}px`;
                }
            },
            close() {
                this.visible = false;
                this.listenForClickOut = false;
                if(window.innerWidth < this.breakpoints.md) {
                    document.body.style.overflow = '';
                    document.body.style.height = ''
                }
            },
            toggle() {
                if(this.visible) { this.close(); }
                else { this.open(); }
            },
            handleCloseButtonClicked() {
                this.close();
            },
            handleClickOut() {
                if(this.listenForClickOut) {
                    this.close();
                }
            },
        },
        created() {
            this.$root.$on('menu::open', this.open);
            this.$root.$on('menu::toggle', this.toggle);
            this.$root.$on('menu::close', this.close);
        },
        mounted() {
            [...this.$el.querySelectorAll('a')]
                .forEach(link => link.addEventListener('click', this.close));

            useClickOut(this, this.handleClickOut);
        },
    }
</script>
